import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Card } from 'primereact/card';
import { Col, Container, Row } from "reactstrap";
import { triggerAlert } from 'utils/CommonFunctions';
import axios from 'axios';
import Logo from '.././assets/images/ats-logo.png';

const RegistrationPage = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        companyId: '',
        companyName: '',
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        password: '',
        confirmPassword: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const validate = () => {
        let tempErrors = {};
        const trimmedData = {
            companyId: formData.companyId.trim(),
            companyName: formData.companyName.trim(),
            userName: formData.userName.trim(),
            firstName: formData.firstName.trim(),
            lastName: formData.lastName.trim(),
            email: formData.email.trim(),
            phoneNumber: formData.phoneNumber.trim(),
            password: formData.password,
            confirmPassword: formData.confirmPassword
        };

        // Company ID
        if (!trimmedData.companyId) tempErrors.companyId = 'Company ID is required';

        // Company Name
        if (!trimmedData.companyName) tempErrors.companyName = 'Please enter a valid company name.';
        else if (!/^[a-zA-Z0-9 &.-]{2,100}$/.test(trimmedData.companyName)) tempErrors.companyName = 'Please enter a valid company name.';

        // User Name
        if (!trimmedData.userName) tempErrors.userName = 'Name should only contain letters (A–Z).';
        else if (!/^[a-zA-Z]{2,50}$/.test(trimmedData.userName)) tempErrors.userName = 'Name should only contain letters (A–Z).';

        // First Name
        if (!trimmedData.firstName) tempErrors.firstName = 'Name should only contain letters (A–Z).';
        else if (!/^[a-zA-Z]{2,50}$/.test(trimmedData.firstName)) tempErrors.firstName = 'Name should only contain letters (A–Z).';

        // Last Name
        if (!trimmedData.lastName) tempErrors.lastName = 'Name should only contain letters (A–Z).';
        else if (!/^[a-zA-Z]{2,50}$/.test(trimmedData.lastName)) tempErrors.lastName = 'Name should only contain letters (A–Z).';

        // Email
        if (!trimmedData.email) tempErrors.email = 'Please enter a valid business or personal email.';
        else {
            const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            if (!emailRegex.test(trimmedData.email)) tempErrors.email = 'Please enter a valid business or personal email.';
            else {
                const disposableDomains = ['10minutemail.com', 'tempmail.org', 'guerrillamail.com', 'mailinator.com'];
                const domain = trimmedData.email.split('@')[1];
                if (disposableDomains.includes(domain)) tempErrors.email = 'Please enter a valid business or personal email.';
            }
        }

        // Phone Number
        if (!trimmedData.phoneNumber) tempErrors.phoneNumber = 'Please enter a valid phone number (e.g. +91 98765 43210 or (617) 123-4567).';
        else if (!/^(\+?\d{1,4}[-.\s]?)?(\(?\d{1,5}\)?[-.\s]?)?\d{1,5}[-.\s]?\d{1,6}$/.test(trimmedData.phoneNumber)) tempErrors.phoneNumber = 'Please enter a valid phone number (e.g. +91 98765 43210 or (617) 123-4567).';

        // Password
        if (!trimmedData.password) tempErrors.password = 'Password must be at least 8 characters with a mix of uppercase, lowercase, numbers, and symbols.';
        else {
            const weakPasswords = ['password123', 'qwerty', '123456', 'password', 'abc123'];
            if (weakPasswords.includes(trimmedData.password.toLowerCase())) tempErrors.password = 'Password must be at least 8 characters with a mix of uppercase, lowercase, numbers, and symbols.';
            else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(trimmedData.password)) tempErrors.password = 'Password must be at least 8 characters with a mix of uppercase, lowercase, numbers, and symbols.';
        }

        // Confirm Password
        if (!trimmedData.confirmPassword) tempErrors.confirmPassword = 'Confirm Password is required';
        else if (trimmedData.password !== trimmedData.confirmPassword) tempErrors.confirmPassword = 'Passwords do not match';

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                const payload = {
                    company: {
                        name: formData.companyName,
                        // company_id: formData.companyId,
                        company_domain:formData.companyId,
                        parent_company: "",
                        company_type: "parent"

                    },
                    user: {
                        first_name: formData.firstName,
                        last_name: formData.lastName,
                        email: formData.email,
                        user_id: formData.userName,
                        password: formData.password,
                        phone_number: formData.phoneNumber
                    }
                };
                await axios.post('/api/v1/parent-company-registration/', payload);
                triggerAlert('success', 'Success', 'Company successfully registered');
                navigate("/", { replace: true });
            } catch (error) {
                const serverError = error.response?.data?.error || 'Registration failed. Please try again.';
                triggerAlert('warning', 'Warning', serverError);
            }
        }
    };

    return (
        <div className="flex justify-content-center align-items-center min-h-screen login-page">
            <Card style={{ width: '50rem' }} className='login-card'>
                <div className="flex justify-content-center align-items-center ">
                    <img src={Logo} width="150" height="64" className='mb-2' />
                </div>
                <div className="p-fluid">
                    <form onSubmit={handleSubmit}>
                        <Row className='mb-3'>
                            <Col lg={12}>
                                <h3 className='login-head mb-3'>Register</h3>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="companyId">Company Domain<span className="text-danger">*</span></label>
                                    <InputText
                                        name="companyId"
                                        value={formData.companyId}
                                        onChange={handleChange}
                                        placeholder="Enter Company ID"
                                        className={errors.companyId ? 'p-invalid' : ''}
                                    />
                                    {errors.companyId && <small className="p-error">{errors.companyId}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="companyName">Company Name<span className="text-danger">*</span></label>
                                    <InputText
                                        name="companyName"
                                        value={formData.companyName}
                                        onChange={handleChange}
                                        placeholder="Enter Company Name"
                                        className={errors.companyName ? 'p-invalid' : ''}
                                    />
                                    {errors.companyName && <small className="p-error">{errors.companyName}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="userName">User Name<span className="text-danger">*</span></label>
                                    <InputText
                                        name="userName"
                                        value={formData.userName}
                                        onChange={handleChange}
                                        placeholder="Enter User Name"
                                        className={errors.userName ? 'p-invalid' : ''}
                                    />
                                    {errors.userName && <small className="p-error">{errors.userName}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="firstName">First Name<span className="text-danger">*</span></label>
                                    <InputText
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        placeholder="Enter First Name"
                                        className={errors.firstName ? 'p-invalid' : ''}
                                    />
                                    {errors.firstName && <small className="p-error">{errors.firstName}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="lastName">Last Name<span className="text-danger">*</span></label>
                                    <InputText
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        placeholder="Enter Last Name"
                                        className={errors.lastName ? 'p-invalid' : ''}
                                    />
                                    {errors.lastName && <small className="p-error">{errors.lastName}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="email">Email<span className="text-danger">*</span></label>
                                    <InputText
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Enter Email"
                                        className={errors.email ? 'p-invalid' : ''}
                                    />
                                    {errors.email && <small className="p-error">{errors.email}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="phoneNumber">Phone Number<span className="text-danger">*</span></label>
                                    <InputText
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        placeholder="Enter Phone Number"
                                        className={errors.phoneNumber ? 'p-invalid' : ''}
                                    />
                                    {errors.phoneNumber && <small className="p-error">{errors.phoneNumber}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="password">Password<span className="text-danger">*</span></label>
                                    <Password
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Enter Password"
                                        toggleMask={true}
                                        feedback={false}
                                        className={errors.password ? 'p-invalid' : ''}
                                    />
                                    {errors.password && <small className="p-error">{errors.password}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col lg={12}>
                                <div className="p-field">
                                    <label htmlFor="confirmPassword">Confirm Password<span className="text-danger">*</span></label>
                                    <Password
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        placeholder="Confirm Password"
                                        toggleMask={true}
                                        feedback={false}
                                        className={errors.confirmPassword ? 'p-invalid' : ''}
                                    />
                                    {errors.confirmPassword && <small className="p-error">{errors.confirmPassword}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <div className='d-flex justify-content-center'>
                                    <Button
                                        className="btn btn-primary btn-main mb-4"
                                        type="submit"
                                    >
                                        Register
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} className='text-center'>
                                <p>Already registered? <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => navigate("/", { replace: true })}>Login</span></p>
                            </Col>
                        </Row>
                    </form>
                </div>
            </Card>
        </div>
    );
};

export default RegistrationPage;